<script setup lang="ts">
import { onMounted, ref } from 'vue'
import StatePanel from '../components/StatePanel.vue'
import { api, listOf } from '../services/api'
import { dateLabel, money } from '../services/format'

const items = ref<any[]>([])
const loading = ref(true)
const error = ref('')
const status: Record<string, string> = { PENDING: '待支付', CANCELLED: '已取消', CLOSED: '已关闭' }
async function load() {
  loading.value = true; error.value = ''
  try { items.value = listOf(await api('/website-demo-orders?page=1&pageSize=50')) }
  catch (reason: any) { error.value = reason?.message || '订单加载失败' }
  finally { loading.value = false }
}
onMounted(load)
</script>

<template><div class="shell subpage"><div class="subpage-head"><div><span class="section-kicker">BOOKINGS</span><h1>我的订场</h1><p>查看待支付、已取消和已关闭的场地订单。</p></div></div><StatePanel v-if="loading" mode="loading" /><StatePanel v-else-if="error" mode="error" :description="error" @retry="load" /><div v-else-if="items.length" class="order-list"><RouterLink v-for="item in items" :key="item.id" class="order-card" :to="{name:'booking-order',params:{id:item.id}}"><div class="order-head"><div><span>{{ item.orderNo }}</span><h2>{{ item.venueName || '场馆订单' }}</h2></div><b>{{ status[String(item.status)] || '处理中' }}</b></div><p>{{ dateLabel(item.date, item.startTime, item.endTime) }}</p><div class="order-courts"><span v-for="court in item.items" :key="court.id">{{ court.courtName || '场地' }}</span></div><div class="order-footer"><strong>{{ money(item.payableCents) }}</strong><span>查看订单</span></div></RouterLink></div><StatePanel v-else mode="empty" title="暂无订场订单" description="选择场馆可订时段后，订单会显示在这里。" /></div></template>
